export default __webpack_public_path__ + "static/kubeproxy-1-1f23b5b09fc50c034872b9754096ddcf.png";